import Switch from '@rio-cloud/rio-uikit/Switch';
import { useId } from 'react';
import { FormattedMessage } from 'react-intl';

export const ExcludeCancelledFilter = (props: { checked: boolean; onChange: (value: boolean) => void }) => {
    const toggleId = useId();

    return (
        <div className="height-100pct display-flex justify-content-between border rounded bg-lightest padding-10">
            <label className="text-size-14 margin-right-10 margin-y-0" htmlFor={toggleId}>
                <FormattedMessage id="outboundOrderBook.compoundManagement.filter.excludeCancelled" />
            </label>
            <Switch checked={props.checked} onChange={props.onChange} keyName={toggleId} />
        </div>
    );
};
